<template>
  <PageHeader>
    <PageTitle :pre-title="__('entities.details')" :title="entity.name">
      <template #afterTitle>
        <Badge class="ml-2" :variant="entity?.typeData?.().badge">
          {{ entity?.typeData?.().label }}
        </Badge>
        <Badge v-if="entity.isGroup" class="ml-2" variant="info">
          {{ __('badges.parent') }}
        </Badge>
      </template>
      <template #actions>
        <div class="d-flex">
          <b-button
            variant="outline-secondary"
            lift
            size="sm"
            :to="{ name: 'entities.list' }"
          >
            <Icon icon="arrow-left" class="mr-2" size="14" />
            {{ __('buttons.back') }}
          </b-button>
          <ActionPopover v-if="canSendRegistrationEmails">
            <b-button
              v-can:users.email.registration
              class="dropdown-item"
              size="sm"
              :disabled="!selectedRows.length"
              @click="sendRegistrationEmails"
            >
              {{ __('users.send-registration-emails') }}
            </b-button>
          </ActionPopover>
        </div>
      </template>
    </PageTitle>

    <HeaderNav>
      <b-nav-item
        :active="$route.name === 'entities.show'"
        data-testid="nav-entities-page"
        :to="{
          name: 'entities.show',
          params: { entityId: $route.params.entityId },
        }"
      >
        {{ __('entities.data') }}
      </b-nav-item>

      <b-nav-item
        :active="
          ['entities.documents.list', 'entities.driveDocuments.list'].includes(
            $route.name
          )
        "
        data-testid="nav-documents-page"
        :to="{
          name: 'entities.documents.list',
          params: { entityId: $route.params.entityId },
        }"
      >
        {{ __('documents.name') }}
      </b-nav-item>

      <b-nav-item
        :active="$route.name === 'entities.users.list'"
        data-testid="nav-users-page"
        :to="{
          name: 'entities.users.list',
          params: { entityId: $route.params.entityId },
        }"
      >
        {{ __('menu.users') }}

        <b-badge v-if="showUsersBadge" variant="soft-secondary" pill>
          {{ entity.usersCount }}
        </b-badge>
      </b-nav-item>

      <b-nav-item
        :active="['entities.products.list'].includes($route.name)"
        data-testid="nav-products-page"
        :to="{
          name: 'entities.products.list',
          params: { entityId: $route.params.entityId },
        }"
      >
        {{ __('entities.products') }}

        <b-badge
          v-if="entity && entity.productsCount > 0"
          variant="soft-secondary"
          pill
        >
          {{ entity.productsCount }}
        </b-badge>
      </b-nav-item>

      <b-nav-item
        v-can:activities.view
        :active="$route.name === 'entities.activities.list'"
        :to="{
          name: 'entities.activities.list',
          params: { entityId: $route.params.entityId },
        }"
      >
        {{ __('entities.activities') }}

        <b-badge
          v-if="entity && entity.activitiesCount && entity.activitiesCount > 0"
          variant="soft-secondary"
          pill
        >
          {{ entity.activitiesCount }}
        </b-badge>
      </b-nav-item>
    </HeaderNav>
  </PageHeader>
</template>

<script>
import HeaderNav from '@/General/HeaderNav.vue'

export default {
  name: 'EntityShowHeader',

  components: { HeaderNav },

  props: {
    entity: {
      type: Object,
      default: () => {
        return {}
      },
    },
    selectedRows: {
      type: Array,
      default: () => [],
    },
    canSendRegistrationEmails: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    showUsersBadge() {
      return (
        this.entity.usersCount > 0 ||
        (this.entity.isChild && this.entity.subsidiaryEntityUsersCount)
      )
    },
  },

  methods: {
    sendRegistrationEmails() {
      this.$emit('sendRegistrationEmailsClick')
    },
  },
}
</script>
